import { createStore } from 'zustand';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

type SearchedPartner = {
  page: number;
  searchedAppId: string;
  searchedBusinessNumber: string;
  searchedCompanyName: string;
  searchedSvcName: string;
};

type PartnerStore = SearchedPartner & {
  setSearchedPartner: ({
    page,
    searchedAppId,
    searchedBusinessNumber,
    searchedCompanyName,
    searchedSvcName
  }: SearchedPartner) => void;
  resetSearchedPartner: () => void;
};

const INITIAL_VALUE = {
  page: 1,
  searchedAppId: '',
  searchedBusinessNumber: '',
  searchedCompanyName: '',
  searchedSvcName: ''
};

export const partnerStore = createStore<PartnerStore>((set) => ({
  ...INITIAL_VALUE,
  setSearchedPartner: ({
    page,
    searchedAppId,
    searchedBusinessNumber,
    searchedCompanyName,
    searchedSvcName
  }: SearchedPartner) => set({ page, searchedAppId, searchedBusinessNumber, searchedCompanyName, searchedSvcName }),
  resetSearchedPartner: () => set(INITIAL_VALUE)
}));

export const usePartnerStore = <T = PartnerStore>(selector = (state: PartnerStore) => state as T) =>
  useStoreWithEqualityFn(partnerStore, selector, shallow);
